import React from "react";

type LoaderProps = {
    size?: number;
    color?: string;
    className?: string;
    isGradient?: boolean;
};

const Loader = ({ size, color, className, isGradient }: LoaderProps) => {
    return isGradient ? (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`animate-spin mx-auto  ${
                !size ? "h-5 w-5" : `h-${size} w-${size}`
            } ${className}`}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM1.8 12C1.8 17.6333 6.36669 22.2 12 22.2C17.6333 22.2 22.2 17.6333 22.2 12C22.2 6.36669 17.6333 1.8 12 1.8C6.36669 1.8 1.8 6.36669 1.8 12Z"
                fill="#EFEFEF"
            />
            <path
                d="M0.9 12C0.402944 12 -0.00351238 12.4035 0.0337288 12.8992C0.188257 14.9559 0.870892 16.9435 2.02236 18.6668C3.34094 20.6402 5.21508 22.1783 7.4078 23.0866C9.60051 23.9948 12.0133 24.2324 14.3411 23.7694C16.6689 23.3064 18.8071 22.1635 20.4853 20.4853C22.1635 18.8071 23.3064 16.6689 23.7694 14.3411C24.2324 12.0133 23.9948 9.60051 23.0866 7.4078C22.1783 5.21509 20.6402 3.34094 18.6668 2.02237C16.9435 0.870893 14.9559 0.188258 12.8992 0.033729C12.4035 -0.00351229 12 0.402944 12 0.9C12 1.39706 12.4037 1.79588 12.8989 1.83968C14.5991 1.99008 16.2396 2.56539 17.6668 3.51901C19.3442 4.6398 20.6516 6.23282 21.4236 8.09663C22.1956 9.96044 22.3976 12.0113 22.004 13.9899C21.6104 15.9685 20.639 17.786 19.2125 19.2125C17.786 20.639 15.9685 21.6104 13.9899 22.004C12.0113 22.3976 9.96043 22.1956 8.09663 21.4236C6.23282 20.6516 4.6398 19.3442 3.51901 17.6668C2.56539 16.2396 1.99008 14.5991 1.83968 12.8989C1.79588 12.4037 1.39706 12 0.9 12Z"
                fill="url(#paint0_linear_33085_317759)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_33085_317759"
                    x1="3.73333"
                    y1="34.9714"
                    x2="29.5112"
                    y2="27.0836"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#56B648" />
                    <stop offset="1" stop-color="#FFB902" />
                </linearGradient>
            </defs>
        </svg>
    ) : (
        <svg
            className={`animate-spin mx-auto  ${
                !size ? "h-5 w-5" : `h-${size} w-${size}`
            } ${className}`}
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-0"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            ></circle>
            <path
                className={` ${color ? `!text-${color}` : "text-tradeally-blue"}`}
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    );
};

export default Loader;
